import React from 'react';
import { Lock } from 'lucide-react';
import { publicProspectPageConfig } from '../../config/publicProspectPageConfig';

export default function PublicProspectHeader({ language, onLanguageChange, disabled, copy }) {
  const isFr = language === 'fr';
  return (
    <header className="flex items-center justify-between gap-3 py-3">
      <img src="/rentalyzer-logo.png" alt="Rentalyzer" className="h-10 w-auto sm:h-12" />
      <div className="prospect-ui flex flex-1 items-center justify-center gap-2 text-sm text-[#004747]">
        <Lock className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="text-center">
          <span className="font-semibold">{copy.confidential}</span>
          <span className="hidden sm:inline"> — {copy.confidentialHint}</span>
        </span>
      </div>
      <div
        className="prospect-ui flex items-center gap-1 text-sm font-medium text-[#004747]"
        role="group"
        aria-label="Language"
      >
        <button
          type="button"
          disabled={disabled || isFr}
          className={`rounded px-1.5 py-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#007c91] ${isFr ? 'underline' : 'opacity-70'}`}
          onClick={() => onLanguageChange('fr')}
        >
          FR
        </button>
        <span aria-hidden="true">|</span>
        <button
          type="button"
          disabled={disabled || !isFr}
          className={`rounded px-1.5 py-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#007c91] ${!isFr ? 'underline' : 'opacity-70'}`}
          onClick={() => onLanguageChange('en')}
        >
          EN
        </button>
      </div>
      <span className="sr-only">{publicProspectPageConfig.contact.name}</span>
    </header>
  );
}
